module.exports = __webpack_public_path__ + "static/banner-img-2-24eeac7708bcab21d6160e904d903a6b.jpg";